const autoTutorSentencesStudent = {
  ACT_English: {
    "Writer's Goal":
      "Improve ability to evaluate whether or not a passage accomplished the author's goal.",
    "Author's Purpose":
      "Improve ability to analyze the impact of the addition or deletion of sentences in an essay.",
    Relevance:
      "Review how to identify and eliminate or improve essay elements that do not develop the author's main idea or that are not relevant to the paragraph.",
    "Accomplish Purpose":
      "Improve ability to recognize words, phrases, or sentences that accomplish a stated purpose.",
    "Introductions & Conclusions":
      "Improve ability to recognize strong introductions and conclusions.",
    "Paragraph Division":
      "Develop your ability to put words and sentences into a logical sequence and to use paragraph structure to logically group ideas in a passage.",
    Transitions:
      "Review the meaning of transitional words and practice choosing phrases that present an author's thoughts in a smooth and logical flow.",
    Conjunctions:
      "Develop your ability to recognize conjunctions that logically link two clauses.",
    Redundancy:
      "Instruct your students to avoid redundancy and wordiness so that they will perform at a higher level on the English test.",
    "Vague & Clumsy Writing":
      "Work to avoid vague or clumsy writing that damages the logic of a sentence.",
    "Word Choice":
      "Improve ability to choose words that accomplish the author's intended effect on the reader.",
    "Faulty Coordination & Subordination":
      "Instruct your students on how to properly use coordinating and subordinating conjunctions to combine clauses.",
    "Sentence Structure Disturbances":
      "Focus on your ability to identify and correct comma splices and run-on sentences while ensuring that all sentences are free of misplaced modifiers, misplaced relative pronouns, and misplaced participial phrases.",
    "Verb Tense & Pronoun Person":
      "Work to maintain tense and pronoun person within the context of the passage.",
    "Adjectives & Adverbs":
      "Work to better understand proper usage of the adverb, adjective, and possessive forms of words and improve ability to select the correct preposition to modify sentence elements.",
    "Confusing Pairs":
      'Develop your awareness of commonly confused pairs of words, such as ""there"" and ""their.""',
    Idioms:
      "Improve your understanding of idioms in order to avoid common errors.",
    Prepositions:
      "Improve your awareness of idiomatically appropriate prepositions.",
    Pronouns:
      "Review how to make pronouns agree with their antecedents and avoid using homonyms of pronouns that are inappropriate to the sentence's meaning and syntax.",
    "Subject-Verb Agreement":
      "Work to identify and correct when subjects and verbs do not agree and review the rules of verb formation.",
    "Colons & Semicolons":
      "Improve your understanding of the proper use of semicolons and colons.",
    "Parenthetical Elements":
      "Clarify the difference in comma usage between restrictive and non-restrictive phrases.",
    "Unnecessary Commas":
      "Avoid placing unnecessary commas that disrupt the flow of the sentence or between compound subjects or compound verbs. ",
    "Forming Verbs":
      "Review how to properly form regular and irregular verbs into infinitives and participles.",
    "Style & Tone":
      "Improve ability to recognize appropriate style and tone in the context of a passage.",
    Apostrophes:
      "Review the rules for using apostrophes in contractions and for possession.",
    "Fragments & Fused Sentences":
      "Review how to identify and correct sentence fragments and fused sentences.",
    Parallelism: "Review how to maintain parallel structure in sentences.",
    "Participial Phrases":
      "Review how to correct participial phrases disrupting sentence structure.",
    "Relative Pronouns":
      "Review how to use relative pronouns to correctly form sentences.",
    "Sentence Placement":
      "Practice placing new sentences in paragraphs in the appropriate logical sequence."
  },
  ACT_Math: {
    "Complex Numbers":
      "Review how to do simple operations using imaginary numbers.",
    "Exponents & Place Values":
      "Improve ability to convert numbers into scientific notation.",
    Fractions: "Refresh your knowledge of basic operations using fractions.",
    Matrices:
      "Review how to calculate the values of operations involving matrices.",
    Arithmetic:
      "Improve ability to solve word problems by using basic mathematical operations.",
    "Creating Expressions":
      "Improve ability to create expressions when given data presented in a word problem or table.",
    "Exponents & Roots":
      "Review exponents and roots and use this information to simplify expressions or determine values.",
    Expressions: "Improve ability to manipulate and simplify expressions.",
    "Inequalities & Absolute Value":
      "Review the method of simplifying an inequality with and without the presence of absolute value.",
    "Solving Equations":
      "Improve ability to solve for specific values using equations that are either given or must be determined from a word problem.",
    "Function Graphs - Coordinate Plane":
      "Review the features of functions and relationships between multiple functions when graphed on a coordinate plane.",
    "Functions - Understanding & Evaluating":
      "Focus on finding the values of functions while avoiding common errors in calculation.",
    "Patterns & Sequences":
      "Review the fundamentals of arithmetic and geometric sequences and patterns and how to determine the sums of those sequences and patterns.",
    "Trig Functions":
      "Review advanced trigonometric concepts, including the unit circle, radians, the trig area formula, inverse trig functions, and graphing trig functions.",
    "Angles & Shapes":
      "Refresh your knowledge of solving for interior angles of a triangle as well as angles along parallel lines.",
    "Area, Perimeter, Volume & Circumference":
      "Review how to solve problems involving area, perimeter, volume, and circumference.",
    "Circles - Plane Geometry":
      "Increase your grasp of the geometry of circles, including the basics of area and circumference as well as more advanced concepts like chords and interior angles.",
    "Slope, Midpoint & Distance":
      "Increase your understanding of equations for lines in the coordinate plane and increase your ability to determine the midpoint and distance between two points.",
    "Translation, Rotation, Reflection & Relative Equations":
      "Review the process of translating, rotating, and reflecting equations on a coordinate plane.",
    Triangles:
      "Review how to find the length of triangle sides using the Pythagorean Theorem and the properties of similar triangles.",
    "Trig Geometry":
      "Review the Laws of Sines and Cosines and how to use their formulae to solve for the missing sides and angles of triangles.",
    "Average, Median & Mode":
      "Refresh your understanding of mean, median, and mode.",
    "Data Interpretation":
      "Improve ability to extract and manipulate data given in either a table or chart.",
    Probability:
      "Review the fundamentals of probability with one or multiple events, including joint and conditional probability.",
    Logic: "Improve ability to manipulate and process logical statements.",
    Factors: "Develop your understanding of factors and multiples.",
    "Circles & Parabolas - Coordinate Plane":
      "Review conic sections and specifically the use of circles and parabolas.",
    "Locating Points":
      "Recognize how to identify points in a coordinate plane from information given in a word problem.",
    "Using Formulas":
      "Develop your ability to apply a given formula to information in a problem.",
    "Number Concepts & Properties":
      "Improve ability to apply number concepts or properties to abstract problems.",
    "Properties of Functions":
      "Develop your understanding of the implications of different aspects of a function.",
    "Function Graphs - Modeling & Relations":
      "Help your student model functions on the coordinate plane and reason about the relationships between functions."
  },
  ACT_Reading: {
    "Draw Conclusions":
      "Develop your ability to identify logical inferences from passage text.",
    Locate:
      "Improve ability to locate specific details in a passage and to use those details to select an appropriate answer.",
    Paraphrase:
      "Practice discerning between appropriate and inappropriate paraphrases when given passage text.",
    "Central Ideas":
      "Review the process of determining the main idea or theme of passages and individual paragraphs.",
    "Summarize Key Ideas & Details":
      "Improve ability to recognize a summary of specific details found in a passage.",
    "Comparative Relationships":
      "Develop your awareness of relationships between characters or concepts in a passage and improve ability to describe those relationships.",
    "Analyze Word & Phrase Choices":
      "Develop your ability to recognize the rhetorical use of specific words or phrases found in a passage.",
    "Interpret Words & Phrases":
      "Improve ability to define specific words or phrases based on the context provided by the passage.",
    Function:
      "Review the structure of a passage and the method of determining the potential role of each detail or paragraph within that structure.",
    "Intent & Purpose":
      "Practice identifying the author's intended purpose for using specific details or arguments within a passage.",
    "Point of View":
      "Improve your familiarity with common attitudes found in passages and appropriate words or phrases to describe those attitudes.",
    "Compare Two Texts":
      "Develop your ability to determine and articulate relationships between two separate texts.",
    "Sequence of Events":
      "Practice identifying the location of an event in a sequence that is not necessarily presented chronologically.",
    "Relate to Passage as a Whole":
      "Improve your understanding of specific components of a passage in the context of the central theme.",
    "Conclusions Two Texts":
      "Develop your ability to draw conclusions from two separate but related texts.",
    "Analyze Structure":
      "Develop your understanding of common text structures and their ability to identify them.",
    "Central Ideas & Themes":
      "Review the process of determining the main idea or theme of passages and individual paragraphs."
  },
  ACT_Science: {
    "Compare or Combine":
      "Improve ability to extract and compare multiple pieces of data given by a figure.",
    "Creating Figures":
      "Practice the process of creating a graph or chart based on data given in a passage or figure.",
    "Interpolation & Extrapolation":
      "Develop your ability to determine additional values based on a trend by analyzing a graph or chart.",
    "New Information":
      "Practice the method of interpreting the effects of new information or definitions in conjunction with information given in the passage or figures.",
    "Select Data & Features":
      "Review the process of reading a graph or chart in order to extract data.",
    Terminology:
      "Review basic science terminology associated with the topics tested on the ACT.",
    "Variables & Mathematical Relationships":
      "Develop your ability to determine common trends in data and the method of establishing mathematical relationships such as equations or averages.",
    Comparison:
      "Develop your ability to identify differences and similarities between two or more experiments.",
    "Experimental Design":
      "Improve your understanding of experimental design and the purpose of particular actions taken by scientists within an experiment.",
    "Prediction & Further Experiments":
      "Practice making predictions of outcomes of additional trials within an experiment based on past experimental data.",
    Text: "Review the process of selecting relevant information about an experiment from passage text.",
    Tools:
      "Improve your understanding of scientific tools and how they are used in an experiment.",
    "Consistency of Hypotheses, Predictions & Conclusions":
      "Develop your ability to determine whether information is consistent with a hypothesis or experiment given in a passage.",
    "Model Information":
      "Develop your ability to assess models and to determine their implications.",
    "Support of Hypotheses":
      "Practice determining how different hypotheses can be used to support specific statements.",
    "Understanding Design":
      "Develop your understanding of experimental design.",
    Hypothesis:
      "Review the definition of a hypothesis and how to identify it in the context of an experiment.",
    Methods:
      "Review common methods used in experimentation and the reasoning behind them.",
    "Support or Weakening of Models":
      "Practice determining whether given information supports or weakens a hypothesis.",
    Controls: "Develop your ability to identify the control in an experiment."
  },

  //TODO: Need new sentences for sat subjects, using defaults for now.
  "SAT_Writing and Language": {
    "Expression of Ideas": "",
    "Effective language use": "",
    Syntax: "",
    "Style and tone": "",
    Concision: "",
    Precision: "",
    Organization: "",
    "Logical sequence": "",
    "Introductions, conclusions, and transitions": "",
    Development: "",
    Support: "",
    Focus: "",
    "Quantitative information (D)": "",
    Proposition: "",
    "Standard English Conventions": "",
    "Sentence structure": "",
    "Sentence formation": "",
    "Sentence boundaries": "",
    "Parallel structure": "",
    "Subordination and coordination": "",
    "Modifier placement": "",
    "Inappropriate shifts in construction": "",
    "Pronoun person and number": "",
    "Verb tense, mood, and voice": "",
    "Conventions of usage": "",
    Agreement: "",
    "Noun agreement": "",
    "Subject-verb agreement": "",
    "Pronoun-antecedent agreement": "",
    "Logical comparison": "",
    "Conventional expression": "",
    "Frequently used words": "",
    Pronouns: "",
    "Pronoun clarity": "",
    "Possessive determiners": "",
    "Conventions of punctuation": "",
    "Unnecessary punctuation": "",
    "End-of-sentence punctuation": "",
    "Possessive nouns and pronouns": "",
    "Within-sentence punctuation": "",
    "Nonrestrictive and parenthetical elements": "",
    "Items in a series": ""
  },
  SAT_Reading: {
    Rhetoric: "",
    Purpose: "",
    "Word choice": "",
    Arguments: "",
    "Assessing reasoning": "",
    "Analyzing evidence": "",
    "Claims and counterclaims": "",
    "Analyzing purpose": "",
    "Point of view": "",
    "Text structure": "",
    "Part-whole relationships": "",
    "Overall structure": "",
    Synthesis: "",
    "Multiple texts": "",
    "Quantitative information (S)": "",
    "Information and Ideas": "",
    Summarizing: "",
    "Understanding relationships": "",
    "Interpreting words and phrases": "",
    "Central ideas and themes": "",
    "Reading closely": "",
    "Explicit meanings": "",
    "Implicit meanings": "",
    "Analogical reasoning": "",
    "Citing textual evidence": ""
  },
  SAT_Math: {
    "Passport to Advanced Math": "",
    "Nonlinear equations": "",
    "Nonlinear functions": "",
    "Equivalent expressions": "",
    "Heart of Algebra": "",
    "Linear equations, two variables": "",
    "Linear functions": "",
    "Linear equations, one variable": "",
    "Systems of equations": "",
    "Linear inequalities": "",
    "Problem Solving and Data Analysis": "",
    "Models and scatterplots": "",
    Probability: "",
    "Center and spread": "",
    "Statistical claims": "",
    Percentages: "",
    "Inference from statistics": "",
    "Rates, proportions, and units": "",
    "Additional Topics in Math": "",
    "Complex numbers": "",
    "Lines, angles, and triangles": "",
    Circles: "",
    "Right triangles and trig": "",
    "Area and volume": ""
  }
}

export default autoTutorSentencesStudent
